module.exports = __webpack_public_path__ + "static/321-39db9f277c4f339d9216f6335352768d.jpg";